import { render, staticRenderFns } from "./forecast-detail-template.vue?vue&type=template&id=754a9538&scoped=true&%23default=true"
import script from "./forecast-detail-template.vue?vue&type=script&lang=js"
export * from "./forecast-detail-template.vue?vue&type=script&lang=js"
import style0 from "./forecast-detail-template.vue?vue&type=style&index=0&id=754a9538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754a9538",
  null
  
)

export default component.exports